<template>
  <div>
    <div class="right-title">
      <span>职位推荐</span>
    </div>
    <div class="content-box">
      <div class="search-box">
<!--        <div style="margin-right: 20px">-->
<!--          <el-input-->
<!--            class="search"-->
<!--            type="text"-->
<!--            placeholder="请输入机构名称或ID、职位名称或ID"-->
<!--            v-model="search"-->
<!--            style="right: 180px;width: 300px;"-->
<!--          >-->
<!--          </el-input>-->
<!--          <el-button class="btn2" @click="keyWord" type="primary">搜索</el-button>-->
<!--        </div>-->
        <el-button plain class="go-back" @click="goBack">返回</el-button>

      </div>

      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',colori: '#000;'}"

        >
<!--          <el-table-column-->
<!--            fixed-->
<!--            type="selection"-->
<!--            v-if="user.admin_type !== 1"-->
<!--            width="55">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="gw_id"
            label="职位推荐人ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="gw_name"
            label="职位推荐人"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_id"
            label="被推荐人ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_real_name"
            label="被推荐人"
            align="center"
            >
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="推荐时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>

        </el-table>
        <div class="page-box">
          <div>
<!--            <el-button type="danger" @click="deleteList">删除</el-button>-->
            共计{{page.pageTotal}}条
            <el-button type="primary" @click="addForm" v-if="user.admin_type !== 1">添加到表单</el-button>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "zwList",
    data() {
      return {
        id:'',
        search: '',  // 搜索
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
        real_count:0,
        formList: [],  // 表单数据
        form: {
          region: '',
          name: ''
        },
        dialogFormVisible: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      fList() {
        let flist = JSON.parse(JSON.stringify(this.formList))
        flist.map(item => {
          item.label = item.name
          item.value = item.id

        })
        return flist
      },
    },
    created() {
      this.$emit('setType', 0)
      this.id = this.$route.params.id
      this.wzList()
    },
    methods: {
      // 职位列表
      wzList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.recommendPositionList({
          search: this.search,
          jobsId:this.id,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
        }).then(res => {
            loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          res.data.map(item => {
            item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)
            //推荐
            item.commend = item.commend === 0 ? (true) : (false)
          })
          this.tableData = res.data
          this.real_count = res.real_count
        }).catch(() => {
            loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      //  返回上一页
      goBack() {
        this.$router.push('/home/zwAdmin/zwList')
      },

      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/zwAdmin/zwaddList/'+this.id,
          query: {
            pageNum: this.page.pageNum,
            key: this.search
          }
        })
      }
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.wzList()
      }
    },
    filters:{
      status(val){
        switch (Number(val)) {
          case 0:
            return '正常'
          case 1:
            return '手动下线'
          case 2:
            return '自动下线'
          case 3:
            return '不信任下线'
          case 4:
            return '审核中下线'
        }
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>